import { MarkHandoverSummaryCompleteCommand } from './mark-handover-summary-complete-command';
import { EditDimensionCommand } from './edit-dimension-command';
import { EditVariationCommand } from './edit-variation-command';
import { EditVariationInstructionCommand } from './edit-variation-instruction-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class MarkVariationSummaryCompleteCommand {
  MarkHandoverSummaryCompleteCommand: MarkHandoverSummaryCompleteCommand;
  EditDimensionCommands: EditDimensionCommand[];
  EditVariationCommand: EditVariationCommand;
  EditVariationInstructionCommand: EditVariationInstructionCommand;
  VariationId: string;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


